import { requestAuthAdmin } from './auth';
import { API_ENV_TEST, API_ENV_PROD, getSelectedEnvironment } from '../utils/apiEnvironment';

export const PROFILE_TAG_REVIEW_PURPOSE = 'PROFILE_TAG_CONTENT_REVIEW';

// These responses contain private, user-entered text. Do not use parseResponse,
// which prints response bodies in development builds.
async function readPrivateResponse(response) {
  if (!response.ok) {
    const error = new Error(`Profile tag read failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  const body = await response.json();
  return body?.data ?? body;
}

function assertEnvironment(expectedEnvironment) {
  if (![API_ENV_TEST, API_ENV_PROD].includes(expectedEnvironment) || expectedEnvironment !== getSelectedEnvironment()) {
    throw Object.assign(new Error('프로필 태그 조회 환경이 변경됐습니다. 다시 열어주세요.'), { status: 409 });
  }
}

const readOptions = {
  method: 'GET',
  headers: { 'X-Moderation-Purpose': PROFILE_TAG_REVIEW_PURPOSE },
};

export async function getUserProfileTags(userId, token, expectedEnvironment = getSelectedEnvironment()) {
  assertEnvironment(expectedEnvironment);
  const id = Number(userId);
  if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Invalid user ID');
  const response = await requestAuthAdmin(`/api-admin/v0/users/profile-tags?user_id=${id}`, readOptions, token);
  return readPrivateResponse(response);
}

export async function getCustomProfileTags({ cursor = null, limit = 20 } = {}, token, expectedEnvironment = getSelectedEnvironment()) {
  assertEnvironment(expectedEnvironment);
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  const response = await requestAuthAdmin(`/api-admin/v0/moderation/profile-tags?${params}`, readOptions, token);
  return readPrivateResponse(response);
}
